import { Injectable } from '@angular/core';
import { WorkItemTypes } from 'common/workitems/constants/workitem-types';
import { BcRestApi } from 'common/api/rest-api';
import { BcSafeSender } from 'common/auth/safe-sender.service';
import { WrapUp } from 'common/api/models/wrap-up.model';
import { PCacheable } from 'ngx-cacheable';
import { UserPermissionService } from 'shared/services/user-permissions/user-permission.service';
import { ActionPermissionType } from 'common/common/constants/permission-type-enum';

@Injectable()
export class WrapupPanelService {
  constructor(private _bcRestApi: BcRestApi,
              private _bcSafeSender: BcSafeSender,
              private _userPermissionService: UserPermissionService) { }

  @PCacheable()
  getWrapUps(type, workItemId) {
    const wrapUps = [];
    let builtInWrapUps: WrapUp[] = [];
    let customWrapUps: WrapUp[] = [];
    let customWrapUpsPromise: Promise<WrapUp[]>;

    const builtInWrapUpsPromise = this._bcRestApi.getBuiltInWrapUps(type, workItemId);

    if (this.hasCustomWrapUp(type) && this._hasCustomChatWrapUpReadAccess()) {
      customWrapUpsPromise = this._bcRestApi.getCustomWrapUps(workItemId);
    }

    return Promise.all([builtInWrapUpsPromise, customWrapUpsPromise]).then((response) => {
      builtInWrapUps = response[0];

      if (response.length > 1) {
        customWrapUps = response[1];
      }
      if ((builtInWrapUps && builtInWrapUps.length > 0) || (customWrapUps && customWrapUps.length > 0)) {
        wrapUps.push(builtInWrapUps, customWrapUps);
        return wrapUps;
      }
      return null;
    });
  }

  hasCustomWrapUp(type) {
    return type === WorkItemTypes.CHAT;
  }

  safeSaveWrapUp(type, workItemId, separatedFields) {
    const saveWrapUpPromises = [];

    if (this.areFieldsValid(separatedFields.filteredBuiltInFields)) {
      saveWrapUpPromises.push(this._bcSafeSender.send(() => this._bcRestApi.saveBuiltInWrapUps(type, workItemId, separatedFields.filteredBuiltInFields)));
    }

    if (type === WorkItemTypes.CHAT && this.areFieldsValid(separatedFields.filteredCustomFields)) {
      saveWrapUpPromises.push(this._bcSafeSender.send(() => this._bcRestApi.saveCustomWrapUps(workItemId, separatedFields.filteredCustomFields)));
    }

    return saveWrapUpPromises;
  }

  areFieldsValid(fields) {
    return fields && fields.length !== 0;
  }

  private _hasCustomChatWrapUpReadAccess(): boolean {
    return this._userPermissionService.hasPermissionFor(ActionPermissionType.CHAT_WRAP_UP_EDIT_OWN) || this._userPermissionService.hasPermissionFor(ActionPermissionType.CHAT_WRAP_UP_EDIT_OTHER);
  }
}
